"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactCompoundSlider = require("react-compound-slider");

var _handleItem = require("./handle-item");

var _trackItem = require("./track-item");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _loadStyles = _interopRequireDefault(require("load-styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".cae65fc31{position:relative;width:100%;height:3.125rem;padding-top:1.3125rem;box-sizing:content-box}.cc77f3e7c{display:none}.c427d7751{position:absolute;width:100%;height:.187rem;margin-top:.937rem;border-radius:.0625rem;cursor:pointer;background-color:var(--color-flomni-gray-40)}.cbc754a0a{display:block}.cb4b36405{transition:left 50ms linear;position:absolute;margin-left:calc(-1.25rem / 2);margin-top:.375rem;z-index:2;box-sizing:border-box;width:1.25rem;height:1.25rem;border-width:.0625rem;border-style:solid;border-color:var(--color-flomni-blue-70);text-align:center;cursor:pointer;border-radius:50%;background-color:#fff;box-shadow:0 .08438rem .16562rem rgba(0,0,0,.2)}.cb4b36405:hover{box-shadow:0 .125rem .25rem rgba(0,0,0,.2)}.cb4b36405:active{box-shadow:0 .0625rem .125rem rgba(0,0,0,.2)}.cec5157a8{margin-top:-1.5625rem;font-size:.875rem;font-weight:400;line-height:1rem;color:var(--color-flomni-gray-90)}.cd3ea54ea{display:block}.c08abe411{transition:width 50ms linear;position:absolute;height:.187rem;z-index:1;margin-top:.937rem;background-color:var(--color-flomni-blue-70);border-radius:.125rem;cursor:pointer}.c5accbf36{display:block}.cb9c1ffa1{position:absolute;margin-top:1.875rem;text-align:center;font-size:.75rem;font-weight:400;line-height:.8125rem;color:var(--color-flomni-gray-40)}.cd55eab71{left:0;right:auto}.c24db180f{left:auto;right:0}");
var styles = {
  root: 'cae65fc31',
  input: 'cc77f3e7c',
  rail: 'c427d7751',
  handles: 'cbc754a0a',
  handle: 'cb4b36405',
  value: 'cec5157a8',
  tracks: 'cd3ea54ea',
  track: 'c08abe411',
  ticks: 'c5accbf36',
  'tick-item': 'cb9c1ffa1',
  '--tick-left': 'cd55eab71',
  '--tick-right': 'c24db180f'
};

var Slider = function Slider(props) {
  var onChange = props.onChange,
      value = props.value,
      min = props.min,
      max = props.max,
      measure = props.measure,
      classes = props.classes;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  var domain = (0, _react.useMemo)(function () {
    return [min, max];
  }, [min, max]);
  var onChangeHandler = (0, _react.useCallback)(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 1),
        value = _ref2[0];

    onChange(value);
  }, [onChange]);
  var rail = (0, _react.useMemo)(function () {
    /* eslint-disable-next-line */
    return function (_ref3) {
      var getRailProps = _ref3.getRailProps;
      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
        className: cn.rail
      }, getRailProps()));
    };
  }, [cn.rail]);
  var handles = (0, _react.useMemo)(function () {
    /* eslint-disable-next-line */
    return function (_ref4) {
      var handles = _ref4.handles,
          getHandleProps = _ref4.getHandleProps;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: cn.handles
      }, handles.map(function (handle) {
        return /*#__PURE__*/_react.default.createElement(_handleItem.HandleItem, {
          className: cn.handle,
          valueClassName: cn.value,
          value: handle.value,
          key: handle.id,
          id: handle.id,
          percent: handle.percent,
          getHandleProps: getHandleProps
        });
      }));
    };
  }, [cn.handle, cn.handles, cn.value]);
  var tracks = (0, _react.useMemo)(function () {
    /* eslint-disable-next-line */
    return function (_ref5) {
      var tracks = _ref5.tracks,
          getTrackProps = _ref5.getTrackProps;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: cn.tracks
      }, tracks.map(function (_ref6) {
        var id = _ref6.id,
            source = _ref6.source,
            target = _ref6.target;
        return /*#__PURE__*/_react.default.createElement(_trackItem.TrackItem, {
          className: cn.track,
          key: id,
          sourcePercent: source.percent,
          targetPercent: target.percent,
          getTrackProps: getTrackProps
        });
      }));
    };
  }, [cn.track, cn.tracks]);
  return /*#__PURE__*/_react.default.createElement(_reactCompoundSlider.Slider, {
    className: cn.root,
    domain: domain,
    step: 1,
    mode: 2,
    values: [value],
    onChange: onChangeHandler
  }, /*#__PURE__*/_react.default.createElement(_reactCompoundSlider.Rail, null, rail), /*#__PURE__*/_react.default.createElement(_reactCompoundSlider.Handles, null, handles), /*#__PURE__*/_react.default.createElement(_reactCompoundSlider.Tracks, {
    right: false
  }, tracks), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.ticks
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(cn.tick.item, " ").concat(cn.tick.left)
  }, min, " ", measure), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(cn.tick.item, " ").concat(cn.tick.right)
  }, max, " ", measure)));
};

exports.Slider = Slider;
Slider.propTypes = {
  /* component logic props */
  value: _propTypes.number.isRequired,
  onChange: _propTypes.func.isRequired,
  min: _propTypes.number.isRequired,
  max: _propTypes.number.isRequired,
  measure: _propTypes.string.isRequired,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
Slider.defaultProps = {
  classes: {}
};